"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Q192 = exports.Q96 = exports.ONE = exports.ZERO = exports.NEGATIVE_ONE = void 0;
const math_1 = require("@sushiswap/math");
// constants used internally but not expected to be used externally
exports.NEGATIVE_ONE = math_1.JSBI.BigInt(-1);
exports.ZERO = math_1.JSBI.BigInt(0);
exports.ONE = math_1.JSBI.BigInt(1);
// used in liquidity amount math
exports.Q96 = math_1.JSBI.exponentiate(math_1.JSBI.BigInt(2), math_1.JSBI.BigInt(96));
exports.Q192 = math_1.JSBI.exponentiate(exports.Q96, math_1.JSBI.BigInt(2));
//# sourceMappingURL=internalConstants.js.map